import { useI18n } from "../i18n";
import { logWarn } from "../lib/log";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentResult({ cancelled }) {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const tries = useRef(0);

  useEffect(() => {
    if (cancelled) return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/stripe/status/${sid}`);
        if (r.data.payment_status === "paid") { await refresh(); setState("paid"); return; }
        if (r.data.status === "failed") { setState("error"); return; }
      } catch (e) { logWarn("Verifica pagamento non riuscita, nuovo tentativo:", e); }
      if (++tries.current < 15) timer = setTimeout(poll, 2000); else setState("error");
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, params, refresh]);

  const view = {
    checking: [<Loader2 key="i" size={40} className="text-cyan animate-spin" />, t("payChecking")],
    paid: [<CheckCircle2 key="i" size={40} className="text-amber" />, t("payPaid")],
    cancelled: [<XCircle key="i" size={40} className="text-muted" />, t("payCancelled")],
    error: [<XCircle key="i" size={40} className="text-red" />, t("payErr")],
  }[state];

  return (
    <div className="ghost-root flex items-center justify-center px-4" data-testid="payment-result-page">
      <div className="scanlines" />
      <div className="panel p-10 max-w-md w-full grid gap-6 justify-items-center text-center relative z-10">
        {view[0]}
        <p className="font-heading text-xl" data-testid="payment-result-message">{view[1]}</p>
        <button className="power-btn" onClick={() => navigate("/")} data-testid="payment-back-home-btn">{t("backHome")}</button>
      </div>
    </div>
  );
}
